import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { isAuthenticated } from '../auth';
import { AddPub1500X400 } from "../auth/apiCategory";
import { MdEdit, MdRemoveRedEye, MdClose } from "react-icons/md";
import { FaDesktop, FaMobileAlt } from "react-icons/fa";
import ErrorAlert from "./ErrorAlert";
import "./imagesLoading.css";
import "./PubUploadForm.css";
import { elakayAutoText } from "./dataElakay";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["pub1500X500"]?.[key] || fallback;

const Pub1200X500 = props => {
    const { token } = isAuthenticated();
    const [days, setDays] = useState(1);
    const [error, setError] = useState(null);
    const [viewImageModal, setViewImageModal] = useState(null);
    const [editImageIndex, setEditImageIndex] = useState(null);

    const {
        elakayCategoryID,
        categories_ID,
        loadCategory,
        ButtonCancel,
        infoSource,
        imagePubID
    } = props;
    __setElakayInfoSource(infoSource);

    const [post, setPost] = useState({
        photos: [],
    });

    const [highlight, setHighlight] = useState(false);
    const { photos } = post;
    const maxImgSize = 2;

    // ImageSizeSelector avec Edit + View
    const ImageSizeSelector = () => {
        const desktopCount = photos.filter(p => p.deviseSize === 'd').length;
        const mobileCount = photos.filter(p => p.deviseSize === 'm').length;

        return (
            <div className="pub-size-selector">
                {/* Desktop & Tablet */}
                <div className={`pub-size-badge pub-size-badge--desktop ${desktopCount > 0 ? 'is-active' : ''}`}>
                    <FaDesktop />
                    <span>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pub1500X500.t001}</span>
                    {desktopCount > 0 && (
                        <span className="pub-size-count pub-size-count--desktop">{desktopCount}</span>
                    )}
                </div>

                {/* Mobile */}
                <div className={`pub-size-badge pub-size-badge--mobile ${mobileCount > 0 ? 'is-active' : ''}`}>
                    <FaMobileAlt />
                    <span>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pub1500X500.t002}</span>
                    {mobileCount > 0 && (
                        <span className="pub-size-count pub-size-count--mobile">{mobileCount}</span>
                    )}
                </div>

                {/* Edit Button */}
                {photos.length > 0 && (
                    <button
                        type="button"
                        className={`pub-action-btn pub-action-btn--edit ${editImageIndex !== null ? 'is-active' : ''}`}
                        onClick={() => setEditImageIndex(editImageIndex === null ? 0 : null)}
                    >
                        <MdEdit />
                        <span>{editImageIndex !== null ? elakayAutoText("h_4d63c1d519408c", "Cancel Edit") : elakayAutoText("h_ce2267a8fe5daf", "Edit Images")}</span>
                    </button>
                )}

                {/* View Button */}
                {photos.length > 0 && (
                    <button
                        type="button"
                        className="pub-action-btn pub-action-btn--view"
                        onClick={() => setViewImageModal(photos[0])}
                    >
                        <MdRemoveRedEye />
                        <span>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pub1500X500.t003}</span>
                    </button>
                )}
            </div>
        );
    };

    const handleFiles = (files) => {
        const incoming = Array.from(files || []);
        if (!incoming.length) return;

        let arrPhotos = [];
        let processed = 0;
        let errors = [];

        const hasDesktopAlready = photos.some(p => p.deviseSize === "d");
        const hasMobileAlready = photos.some(p => p.deviseSize === "m");

        const done = () => {
            if (arrPhotos.length > 0) {
                const room = maxImgSize - photos.length;
                const add = arrPhotos.slice(0, room);
                if (add.length) {
                    setPost(prev => ({ ...prev, photos: [...prev.photos, ...add] }));
                }
            }

            if (errors.length > 0) {
                setError(errors.flat());
            }
        };

        incoming.forEach((file) => {
            const reader = new FileReader();

            reader.onload = () => {
                const img = new Image();

                img.onload = () => {
                    const naturalW = img.width;
                    const naturalH = img.height;

                    let detectedDeviseSize = null;

                    if (naturalW === 1200 && naturalH === 500) detectedDeviseSize = "d";
                    else if (naturalW === 800 && naturalH === 500) detectedDeviseSize = "m";

                    if (!detectedDeviseSize) {
                        errors.push([
                            elakayAutoText("h_de4db34c2c88a9", "❌ Invalid image dimensions. Accepted formats are:"),
                            elakayAutoText("h_606d3f63372f4d", "• 1200 x 500 pixels for Desktop & Tablet"),
                            elakayAutoText("h_b6dba72766a7db", "• 800 x 500 pixels for Mobile"),
                            "",
                            elakayAutoText("h_f24a26cc64d41d", "Your image \"{value0}\":", { value0: file.name }),
                            elakayAutoText("h_ff9a956c2c1567", "• {value0} x {value1} pixels ❌", { value0: naturalW, value1: naturalH }),
                            ""
                        ]);
                        processed++;
                        if (processed === incoming.length) done();
                        return;
                    }

                    const alreadyInBatch = arrPhotos.some(p => p.deviseSize === detectedDeviseSize);
                    const alreadyInState = detectedDeviseSize === "d" ? hasDesktopAlready : hasMobileAlready;

                    if (alreadyInBatch || alreadyInState) {
                        const isD = detectedDeviseSize === "d";
                        const needOther = isD
                            ? elakayAutoText("h_b97c18a15cd3b9", "Mobile (800 x 500)")
                            : elakayAutoText("h_e37f093b6d5762", "Desktop (1200 x 500)");

                        errors.push([
                            elakayAutoText("h_58eba3b8653e63", "⚠️ You selected 2 images with the SAME size ({value0}).", { value0: isD ? "1200 x 500" : "800 x 500" }),
                            elakayAutoText("h_282430df5b5400", "✅ The first one will be kept."),
                            elakayAutoText("h_c53709b9da64ec", "❌ The other one will be ignored."),
                            "",
                            elakayAutoText("h_bb6ecd6faa9cba", "Please add the other size: {value0}.", { value0: needOther }),
                            ""
                        ]);

                        processed++;
                        if (processed === incoming.length) done();
                        return;
                    }

                    arrPhotos.push({
                        file,
                        name: file.name,
                        type: file.type,
                        size: file.size,
                        src: reader.result,
                        naturalW,
                        naturalH,
                        deviseSize: detectedDeviseSize,
                    });

                    processed++;
                    if (processed === incoming.length) done();
                };

                img.src = reader.result;
            };

            reader.readAsDataURL(file);
        });
    };

    const handlefilechange = (e) => {
        handleFiles(e.target.files);
    };

    const handledelete = (imgIndex) => {
        setPost((prev) => ({
            ...prev,
            photos: prev.photos.filter((_, i) => i !== imgIndex),
        }));
    };

    const handlehighlight = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setHighlight(true);
    };

    const handleunhighlight = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setHighlight(false);
    };

    const handledrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setHighlight(false);
        handleFiles(e.dataTransfer.files);
    };

    const handleSubmit = async () => {
        try {
            const photosMapped = photos?.map((f) => ({
                file: f.file,
                naturalW: f.naturalW,
                naturalH: f.naturalH,
                deviseSize: f.deviseSize
            })) || [];

            const data = await AddPub1500X400(token, days, elakayCategoryID, photosMapped, imagePubID);

            if (!data || !data.success) {
                setError(data?.errors || [elakayAutoText("h_ad0d0603e2aad1", "Upload failed")]);
                return;
            }

            setError(null);
            setPost({ photos: [] });
            loadCategory(categories_ID);

        } catch (err) {
            console.error(err);
            setError([elakayAutoText("h_831b916850bbfe", "Unexpected error")]);
        }
    };

    const handleChange = event => {
        setDays(event.target.value);
    };

    const nbrDayForm = () => (
        <div className="pub-days-card">
            <span className="pub-days-label">
                {infoSource.laguangeElakay('title', infoSource.languageAPI).nomber}
                <strong>{days}</strong>
                {infoSource.laguangeElakay('title', infoSource.languageAPI).days}
            </span>
            <input
                onChange={handleChange}
                type="number"
                className="pub-days-input"
                min="1"
                max="99"
                value={days}
            />
        </div>
    );

    const ViewImageModal = () => {
        if (!viewImageModal) return null;

        return (
            <Modal
                show={!!viewImageModal}
                onHide={() => setViewImageModal(null)}
                fullscreen
                contentClassName="pub-modal-shell"
                backdropClassName="pub-modal-backdrop-bs"
            >
                <Modal.Body className="pub-modal-body" onClick={() => setViewImageModal(null)}>
                    <div className="pub-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button type="button" className="pub-modal-close" onClick={() => setViewImageModal(null)}>
                            <MdClose />
                        </button>
                        <img
                            className="pub-modal-image"
                            src={viewImageModal.src}
                            alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pub1500X500.t004}
                        />
                        <div className="pub-modal-caption">
                            <p>
                                {viewImageModal.deviseSize === "d" ? elakayAutoText("h_c27eb279275995", "📺 Desktop & Tablet") : elakayAutoText("h_14ec55e192af50", "📱 Mobile")}
                            </p>
                            <p>{viewImageModal.naturalW} x {viewImageModal.naturalH}{__elakayText("t008", "pixels")}</p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    };

    const formatBytes = (bytes = 0) => {
        if (!bytes) return "0 B";
        const k = 1024;
        const sizes = ["B", "KB", "MB", "GB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return `${(bytes / Math.pow(k, i)).toFixed(i === 0 ? 0 : 1)} ${sizes[i]}`;
    };

    const previewCardStyle = (img) => ({
        aspectRatio: img?.naturalW && img?.naturalH ? `${img.naturalW} / ${img.naturalH}` : "1 / 1",
    });

    const ImagesForm = () => (
        <div className="m-3">
            <form encType="multipart/form-data">
                <div className="pub-preview-grid">
                    {photos?.length > 0 &&
                        photos.map((a, i) => (
                            <div key={i} className="pub-preview-card" style={previewCardStyle(a)}>
                                <button type="button" className="pub-preview-delete" onClick={() => handledelete(i)}>×</button>

                                <span className="pub-preview-filesize">{formatBytes(a.size)}</span>

                                <img className="pub-preview-img" src={a.src} alt={a.name} />

                                <span className={`pub-preview-devicebadge pub-preview-devicebadge--${a.deviseSize === "d" ? "desktop" : "mobile"}`}>
                                    {a.deviseSize === "d" ? elakayAutoText("h_5398fafb6beb2c", "📺 Desktop") : elakayAutoText("h_14ec55e192af50", "📱 Mobile")} ({a.naturalW}×{a.naturalH})
                                </span>

                                {editImageIndex === i && (
                                    <div className="pub-preview-editoverlay">
                                        <MdEdit />
                                    </div>
                                )}
                            </div>
                        ))}
                </div>

                <ImageSizeSelector />

                <div className="custom-form-group">
                    {photos.length < maxImgSize ? (
                        <div
                            className={highlight ? "custom-file-drop-area highlight" : "custom-file-drop-area"}
                            onDragEnter={handlehighlight}
                            onDragOver={handlehighlight}
                            onDragLeave={handleunhighlight}
                            onDrop={handledrop}
                        >
                            <input
                                type="file"
                                name="photos"
                                multiple
                                id="filephotos"
                                onChange={handlefilechange}
                                accept="image/*"
                            />
                            <label htmlFor="filephotos">
                                {photos.length}{__elakayText("t006", "images of")}{maxImgSize}
                                <br />{__elakayText("t009", "Add")}{maxImgSize - photos.length}{__elakayText("t010", "more")}<br />{__elakayText("t007", "Drag & Drop")}</label>
                        </div>
                    ) : (
                        <div className="custom-file-drop-area redlight">
                            <label htmlFor="filephotos">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pub1500X500.t005}</label>
                        </div>
                    )}
                </div>
            </form>

            <ErrorAlert error={error} setError={setError} duration={10000} />

            <div className="pub-page-actions">
                <button type="button" className="pub-cancel-btn" onClick={ButtonCancel}>
                    {infoSource.laguangeElakay('Button', infoSource.languageAPI).cancel}
                </button>
                {(() => {
                    const desktopCount = photos.filter(p => p.deviseSize === 'd').length;
                    const mobileCount = photos.filter(p => p.deviseSize === 'm').length;
                    const hasComplete = desktopCount === 1 && mobileCount === 1;

                    return hasComplete ? (
                        <button type="button" className="pub-submit-btn" onClick={handleSubmit}>{__elakayText("t011", "Submit")}</button>
                    ) : (
                        <button type="button" className="pub-submit-btn" disabled>{__elakayText("t011", "Submit")}{!hasComplete && `(${desktopCount}/1 Desktop, ${mobileCount}/1 Mobile)`}
                        </button>
                    );
                })()}
            </div>
        </div>
    );

    const showPuB1500X400 = () => (
        <div className="pub-page-shell">
            <div className="pub-page-header">
                <FaDesktop />
                <h3>{infoSource.laguangeElakay('title', infoSource.languageAPI).pub1500x500}</h3>
            </div>
            <div className="pub-page-body">
                {nbrDayForm()}
                {ImagesForm()}
            </div>
            <ViewImageModal />
        </div>
    );

    return (
        <div>
            {showPuB1500X400()}
        </div>
    );
};

export default Pub1200X500;
